// extracted by mini-css-extract-plugin
var _1 = "default__Cfrnu";
var _2 = "bodyBold__O4pen";
var _3 = "bold__fZzfG";
var _4 = "caption__gDFks";
var _5 = "h1__lYp7y";
var _6 = "h2__GP8F_";
var _7 = "medium__HyJSm";
var _8 = "menu__jIvRp";
var _9 = "semiBold__hOV2y";
var _a = "subText__NfaeT";
var _b = "title__IuNlT";
export { _1 as "_default", _2 as "bodyBold", _3 as "bold", _4 as "caption", _5 as "h1", _6 as "h2", _7 as "medium", _8 as "menu", _9 as "semiBold", _a as "subText", _b as "title" }
export default { "_default": _1, "bodyBold": _2, "bold": _3, "caption": _4, "h1": _5, "h2": _6, "medium": _7, "menu": _8, "semiBold": _9, "subText": _a, "title": _b }
